import Vue from 'vue';
import _store from '@/store';

export {_store as store};

//------------------------------------------------------------------------------------------------------//
//                                                                                                      //
//                                Variable                                                              //
//                                                                                                      //
//------------------------------------------------------------------------------------------------------//
export const state = {
  store: _store.state,
  // States from Vuex store
  local: Vue.observable({
    // Setup local state here (States which don't shared or long-term keeping);

    isProcessing: true,

    //manual data

    courseOutlines: [],

    classRoomPlaceholderIndex: 0,

  })
};

export const template = {
  table: {
    header: [
      {title: 'live-class-schedule.no', id: 'no'},
      {title: 'live-class-schedule.subject-code', id: 'subjectCode'},
      {title: 'live-class-schedule.subject-name', id: 'subjectName'},
      {title: 'live-class-schedule.section', id: 'classSectionQty'},
      {title: 'class-section.learn-span-no', id: 'learnSpanNo'},
      {title: 'student-enroll.student-qty', id: 'studentQty'},
      {title: 'general.manage', id: '', width: 100},
    ]
  },
};


//------------------------------------------------------------------------------------------------------//
//                                                                                                      //
//                                Function                                                              //
//                                                                                                      //
//------------------------------------------------------------------------------------------------------//


export const loadData = async (func) => {

  let payload = {
    courseOutlineFilterInput: {
      currentTeacher: true,
    }
  };

  if (func.getCourseOutlinesByFilter) {
    state.local.courseOutlines = await func.getCourseOutlinesByFilter(payload);
  }

};

//------------------------------------------------------------------------------------------------------//
//                                                                                                      //
//                                Private Function                                                      //
//                                                                                                      //
//------------------------------------------------------------------------------------------------------//
